export default "__VITE_ASSET__DT0Rt8Am__"